package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.BlackOverlay
import com.anjuros.website.components.TemplatesHeader
import com.anjuros.website.components.addStylesheet
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.detectLanguage
import com.anjuros.website.components.detectMode
import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.LanguageContext
import com.anjuros.website.components.language.LocalLanguage
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.language.isContentSelected

import com.anjuros.website.components.setMeta
import com.anjuros.website.components.shared.TemplatePromoFab
import com.anjuros.website.templates.mix.modules.HintBoxDisplay
import com.anjuros.website.templates.selection.modules.Template
import com.anjuros.website.templates.selection.styles.HeaderHeight
import com.anjuros.website.templates.template5.sections.Template5AboutSection
import com.anjuros.website.templates.template5.sections.Template5ContactSection
import com.anjuros.website.templates.template5.sections.Template5FaqSection
import com.anjuros.website.templates.template5.sections.Template5FooterSection
import com.anjuros.website.templates.template5.sections.Template5Header
import com.anjuros.website.templates.template5.sections.Template5MainSection
import com.anjuros.website.templates.template5.sections.Template5ProductSection
import com.anjuros.website.templates.template5.sections.Template5ReviewSection
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Position

@Page
@Composable
fun BakerWebsiteDesignUk() {
    var lang by remember { mutableStateOf(Language.EN) }
    val uiMode = remember { mutableStateOf<UiMode?>(null) }
    var showModeToggleSpotlight by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {

        setMeta(
            "Baker website design UK | Bakery websites",
            "Professional website design for bakers and small food businesses in the UK. Show your products and attract more customers.",
            image = "https://www.soletraderwebsite.co.uk/bakery_template.jpg",
            url = "https://www.soletraderwebsite.co.uk/baker-website-design-uk"
        )
        addStylesheet("/css/styles_bakery.css")
        lang = detectLanguage()
        uiMode.value = detectMode()

        showModeToggleSpotlight =
            uiMode.value != null && localStorage.getItem(HintBoxDisplay).isNullOrEmpty()
    }

    val languageContext = remember(lang) {
        LanguageContext(
            lang = lang,
            setLang = { lang = it }
        )
    }

    val contentMode = uiMode.value ?: UiMode.NORMAL

    CompositionLocalProvider(
        LocalLanguage provides languageContext,
        LocalUiMode provides contentMode
    ) {
        Box(modifier = Modifier.fillMaxSize()) {
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                Template5Header(modifier = HeaderHeight.toModifier())
                Template5MainSection(
                    modifier = Modifier
                )
                Template5ProductSection()
                Template5AboutSection()
                Template5ReviewSection()
                Template5FaqSection()
                Template5ContactSection()
                Template5FooterSection()


            }


            if (showModeToggleSpotlight) {
                BlackOverlay()
            }


            TemplatesHeader(
                modifier = Modifier.align(Alignment.TopCenter)
                    .position(Position.Fixed)
                    .zIndex(100),
                template = Template.Template5,
                showModeToggleSpotlight = showModeToggleSpotlight,
                onDismissSpotlight = {
                    showModeToggleSpotlight = false
                },
                contentModeSelected = uiMode.value.isContentSelected(),
                onChangeMode = { newMode ->
                    uiMode.value = newMode
                    changeMode(newMode)
                }
            )



            TemplatePromoFab()


        }
    }
}